import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import {useNavigate } from "react-router-dom";
import { Checkbox, Form, Radio } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "antd/dist/antd.min.css";
import "../styles/Main.scss";
import { postRequest } from "../axios";
import { ReactComponent as Email } from "../image/Email.svg";
import newLogo from "../image/PROCEM3.svg";
import otpimg from "../image/otpimg.png";
import PhoneIcon from "../image/MobileIcon.svg";
import EmailIcon from "../image/email-icon.svg";
import WhatsAppIcon from "../image/WhatsappIcon.svg";
import EmailField from "../common/htmlComponents/EmailField";
import ButtonField from "../common/htmlComponents/ButtonField";
import Left from "../image/left.png";

const LoginWithEmailOtp = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [otpLogin, setOtpLogin] = useState("email");

  const initialState = {
    otp_method: otpLogin,
    whatsapp_verified: false,
    phone: null,
    email: null,
  };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);

  const handleRadioChange = (e) => {
    setOtpLogin(e.target.value);
    setState({ ...state, otp_method: e.target.value });
  };
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const phoneValidLength = state.phone;

  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 12) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error("Please enter valid phone."));
    }
    return Promise.resolve();
  };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      const payload = { ...state };
      if (payload.email) {
        payload.email = payload.email.toLowerCase();
      }
      const apiResponse = await postRequest("email-otp-login/", payload);
      if (apiResponse.data.success) {
        if (otpLogin === "email") {
          navigate(`/verify/email/` + btoa(state.email));
        }
      }
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
    }
  };
  return (
    <>
      <section className="Login-Form-Page LoginWithOtp">
        <div className="loginleft">
          <div className="wrapper fadeInDown">
            <div>
              <div className="loginimgdiv">
                <img src={otpimg} alt="Smart Buyer Logo"></img>
              </div>
            </div>
          </div>
        </div>
        <div className="loginright">
          <div className="wrapper fadeInDown">
            <div onClick={() => navigate(`/login`)} className="backButton">
              <img src={Left} alt="Back" />
              <span>Back</span>
            </div>
            <div className="formContent">
              <img
                className="NavLogo"
                src={newLogo}
                // width={"220px"}
                height={"50px"}
                alt="Smart Buyer Logo"
              ></img>
              <Form onFinish={handleSubmit} className="Cust-Form">
                <div className="Otp-Opt" style={{ display: "none" }}>
                  <Form.Item>
                    <Radio.Group value={otpLogin} onChange={handleRadioChange}>
                      <Radio value="phone" className="Mobile-Otp ">
                        <img
                          className="Mobile-Icon"
                          src={PhoneIcon}
                          alt="Phone Icon"
                        ></img>
                      </Radio>
                      <Radio value="email" className="Email-Otp">
                        <img
                          className="EmailOtp"
                          src={EmailIcon}
                          alt="Email Icon"
                        ></img>
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
                <div className="email">
                  <div className="FormTitle mt-3">
                    <h1>Login with Email OTP</h1>
                  </div>
                  <span className="email-phone-title">
                    Please enter your Registered Email
                  </span>
                  <div className="TextFeild">
                    <EmailField
                      name="email"
                      prefix={<Email />}
                      placeholder={t("pl_login_with_email")}
                      rules={t("val_email1")}
                      handleInputChange={handleInputChange}
                    />

                    <ButtonField
                      className="GradiantBtn mt-2"
                      type="primary"
                      htmlType="submit"
                      loading={btnLoading}
                      label={t("pl_get_otp")}
                    ></ButtonField>
                  </div>
                </div>
                <div style={{ display: "none" }}>
                  <span className="email-phone-title">
                    {otpLogin === "email"
                      ? t("registered_email_label")
                      : t("registered_mobile_label")}
                  </span>
                  <div className="TextFeild">
                    {otpLogin === "email" ? (
                      <EmailField
                        name="email"
                        prefix={<Email />}
                        placeholder={t("pl_login_with_email")}
                        rules={t("val_email")}
                        handleInputChange={handleInputChange}
                      />
                    ) : (
                      <>
                        <Form.Item
                          name="phone"
                          rules={[
                            {
                              required: true,
                              validator: validatePhoneNumber,
                              message: <Trans> {t("val_phone")}</Trans>,
                            },
                          ]}
                        >
                          <PhoneInput
                            country={"in"}
                            className="PhoneSection"
                            value={state.phone}
                            onChange={(phone) =>
                              setState({ ...state, phone: phone })
                            }
                          />
                        </Form.Item>
                        <div className="CheckBoxFeild">
                          <Form.Item name="whatsapp_verified">
                            <Checkbox
                              checked={state.whatsapp_verified}
                              onChange={(e) =>
                                setState({
                                  ...state,
                                  whatsapp_verified: e.target.checked,
                                })
                              }
                            >
                              Get Otp via WhatsApp
                              <img
                                className="WhatsappIcon"
                                src={WhatsAppIcon}
                                alt="WhatsApp Icon"
                              ></img>
                            </Checkbox>
                          </Form.Item>
                        </div>
                      </>
                    )}
                  </div>

                  <Form.Item>
                    <ButtonField
                      className="GradiantBtn mt-4"
                      type="primary"
                      htmlType="submit"
                      loading={btnLoading}
                      label={t("pl_get_otp")}
                    ></ButtonField>
                  </Form.Item>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LoginWithEmailOtp;
